import { SoftwareSystem, UserModel } from './models';

export const AUTH_TOKEN_NAME = 'X-Auth-Token';

export interface AuthConfig {
  tokenName: string;
  loginUrl?: string;
  preLoginUrl?: string;
}

export class CoreConfig {
  appName: string;
  appUrl: string;
  appId: number;
  env: string;
  shortEnv: string;
  auth: AuthConfig;
  prmUrl: string;
  healthCheckUrl?: string;
  reverseProxyCidr?: string;
  kms?: {
    region: string,
    keyId: string
  };
  cas: { host: string; };

  constructor(props: Partial<CoreConfig>) {
    Object.assign(this, props);
  }

  get appUser(): SoftwareSystem {
    return UserModel.create({
      id: this.appId,
      name: this.appName,
      url: this.appUrl
    }) as SoftwareSystem;
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/common/CoreConfig.ts